import { authHeader } from 'Services/helpers/authHeader';

export function standardHeadersWithAuth() {
  let headers = authHeader();
  headers['Content-Type'] = 'application/json';
  headers['Accept'] = 'application/json';

  return headers;
}